export const OrderIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.58331 19.1667C3.07915 19.1667 2.64755 18.9872 2.28852 18.6281C1.92949 18.2691 1.74998 17.8375 1.74998 17.3333V6.99793C1.47498 6.82987 1.25345 6.61216 1.0854 6.3448C0.917341 6.07744 0.833313 5.76807 0.833313 5.41668V2.66668C0.833313 2.16251 1.01283 1.73091 1.37185 1.37189C1.73088 1.01286 2.16248 0.833344 2.66665 0.833344H17.3333C17.8375 0.833344 18.2691 1.01286 18.6281 1.37189C18.9871 1.73091 19.1666 2.16251 19.1666 2.66668V5.41668C19.1666 5.76807 19.0826 6.07744 18.9146 6.3448C18.7465 6.61216 18.525 6.82987 18.25 6.99793V17.3333C18.25 17.8375 18.0705 18.2691 17.7114 18.6281C17.3524 18.9872 16.9208 19.1667 16.4166 19.1667H3.58331ZM3.58331 7.25001V17.3333H16.4166V7.25001H3.58331ZM2.66665 5.41668H17.3333V2.66668H2.66665V5.41668ZM7.24998 11.8333H12.75V10H7.24998V11.8333Z"
      fill="black"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.41669 17.25C2.91252 17.25 2.48092 17.0705 2.1219 16.7115C1.76287 16.3524 1.58335 15.9208 1.58335 15.4167V3.5H0.666687V1.66667H5.25002V0.75H10.75V1.66667H15.3334V3.5H14.4167V15.4167C14.4167 15.9208 14.2372 16.3524 13.8781 16.7115C13.5191 17.0705 13.0875 17.25 12.5834 17.25H3.41669ZM12.5834 3.5H3.41669V15.4167H12.5834V3.5ZM5.25002 13.5833H7.08335V5.33333H5.25002V13.5833ZM8.91669 13.5833H10.75V5.33333H8.91669V13.5833Z"
      fill="black"
    />
  </svg>
);

export const ExitIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.58333 17.25C2.07917 17.25 1.64757 17.0705 1.28854 16.7115C0.929514 16.3524 0.75 15.9208 0.75 15.4167V2.58333C0.75 2.07917 0.929514 1.64757 1.28854 1.28854C1.64757 0.929514 2.07917 0.75 2.58333 0.75H9V2.58333H2.58333V15.4167H9V17.25H2.58333ZM12.6667 13.5833L11.4062 12.2542L13.7438 9.91667H6.25V8.08333H13.7438L11.4062 5.74583L12.6667 4.41667L17.25 9L12.6667 13.5833Z"
      fill="black"
    />
  </svg>
);
